import { useState } from 'react';
import css from './DirectoryPage.module.css';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  GenericHero,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  PrimaryButton,
  NamedLink,
} from '../../components';
import { TopbarContainer } from '..';
import GPForm from './GPForm';
import ReactPaginate from 'react-paginate';
import { updateNhsAddress } from '../DeafUserVideoAccessPage/DeafUserVideoAccessPage.duck';
import { useDispatch } from 'react-redux';
import data from '../../data/signalise.json';
import { connect } from 'react-redux';
import { ensureCurrentUser } from '../../util/data';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { useHistory } from 'react-router-dom';
import { types as sdkTypes } from '../../util/sdkLoader';
import signalisejson from '../../data/signalise.json';
import { useOutOfHours } from '@/hooks/useOutOfHours';
import { useDirectoryList } from './hooks/useDirectoryList';
import { useUrlSearchParams } from 'use-url-search-params';
import { OrganisationLogo } from './OrganisationLogo';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import thumbsHand from './Helping_Hand_5_TRANSPARENTBG.png';
import surprisedHand from './Helping_Hand_7_TRANSPARENTBG.png';
import { isScrollingDisabled } from '../../ducks/UI.duck';

const getWindow = () => {
  return typeof window === 'undefined'
    ? { location: { search: '', pathname: '' }, history: {} }
    : window;
};

const { LatLng } = sdkTypes;

function DirectoryPage({ user, currentUserLoading, scrollingDisabled }) {
  const dispatch = useDispatch();
  const [inProgress, setInProgress] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const history = useHistory();
  const [initialProps, setInitialProps] = useState(undefined);
  const outOfHours = useOutOfHours();
  const [params, setParams] = useUrlSearchParams({
    name: undefined,
    beginsWith: undefined,
    page: '1',
    size: '20',
  });
  const {
    directoryList,
    pageMeta,
    loading: directoryLoading,
    error: directoryError,
  } = useDirectoryList(params);

  if (currentUserLoading) {
    return <LoadingPage />;
  }

  const currentUser = ensureCurrentUser(user);
  const privateData = user?.attributes.profile.privateData || {};
  const userGpCode = privateData?.deafUserGpCode;
  const userGpName = privateData?.deafUserGpName;
  const userGpAddress = privateData?.deafUserGpAddress;
  const userGpCoords = privateData?.deafUserGpCoords;
  const types = currentUser?.attributes?.profile?.privateData?.userTypes || [];
  const isVRSCustomer = types.includes('VRSCustomer');
  const isDeafUser = types.includes('deafUser');

  const handleSubmit = async (values) => {
    const { addressLocation } = values;
    const { address, department, code } = addressLocation;

    const phoneNumberMaybe = signalisejson?.find(
      (s) => s.code == code
    )?.phoneNumber;

    setInProgress(true);
    setUpdateError(null);
    try {
      if (code != 'K35262') {
        const response = await dispatch(
          updateNhsAddress(address, department, code)
        );
      }
      history.push({
        pathname: '/video-service',
        state: {
          videoInfo: { address, department, code },
          phonenumber: phoneNumberMaybe,
          isGPCall: true,
        },
      });
    } catch (err) {
      setUpdateError('Sorry we were unable to save the address');
      console.log(err);
    } finally {
      setInProgress(false);
    }
  };

  let signaliseLocations = data
    .filter((item) => {
      return item.phoneNumber;
    })
    .map((item) => {
      return {
        key: item.code ? item.code.trim() : null,
        code: item.code ? item.code.trim() : null,
        email: item.email ? item.email.trim() : null,
        department: item.department ? item.department.trim() : null,
        address: item.address,
        label: item.address.place
          ? `${item.department}, ${item.address.place}`
          : `${item.department}`,
        value: item.code,
        contractCode: item.contractCode,
      };
    });

  signaliseLocations.unshift({
    key: '9999',
    code: '9999',
    email: null,
    department: "I can't find my doctor",
    address: { place: '', coords: { lat: 0, lng: 0 } },
    label: "I can't find my doctor",
    value: '9999',
    contractCode: '9999',
  });

  const customGpCode = userGpCode
    ? signaliseLocations.find((i) => i.key == userGpCode)
    : undefined;

  const customGpAddress =
    userGpAddress && userGpCoords
      ? {
          search: userGpAddress,
          selectedPlace: {
            address: userGpAddress,
            origin: new LatLng(userGpCoords[0], userGpCoords[1]),
          },
        }
      : undefined;

  const initialValues = {
    addressLocation: customGpCode,
    GpName: userGpName,
    GpAddress: customGpAddress,
    ...((typeof initialProps != 'undefined' && initialProps) || {}),
  };

  function handlePageClick(e) {
    setParams({ page: e.selected + 1 });
  }

  function handleFilterClick(e) {
    e.preventDefault();
    const link = e.target;
    const filterValue = link.textContent;
    setParams({ beginsWith: filterValue });
  }

  const filterOptions = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];

  function activeFilterClass(option) {
    return option === params.beginsWith ? css.active : '';
  }

  function filterHref(option) {
    const pageLocation = getWindow().location.pathname;
    const searchParams = new URLSearchParams(
      getWindow().location.search.replace('?', '')
    );

    if (option) {
      searchParams.set('beginsWith', option);
    } else {
      searchParams.delete('beginsWith');
    }

    return pageLocation + '?' + searchParams.toString();
  }

  const VRSForm = () => {
    history.push({
      pathname: '/video-service',
      state: {
        isVRSCall: true,
      },
    });
  };

  return (
    <Page
      className={css.directoryPageRoot}
      title="Video Directory"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: 'Video Directory',
      }}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <GenericHero
              className={css.hero}
              title="Video Directory"
              subTitle="Call using a Sign Language Video Interpreter"
            >
              {currentUser.id && (
                <div className={css.doctorSelector}>
                  {isDeafUser && (
                    <GPForm
                      initialValues={initialValues}
                      outOfHours={outOfHours}
                      onSubmit={(values) => {
                        const {
                          GpAddress: customAddress,
                          GpName: department,
                          addressLocation,
                        } = values;

                        if (!addressLocation.code) {
                          const { address, origin } =
                            customAddress.selectedPlace;

                          setInitialProps({
                            addressLocation,
                            GpName: department,
                            GpAddress: customAddress,
                            code: 9999,
                          });

                          handleSubmit({
                            addressLocation: {
                              address: {
                                place: address,
                                coords: { lat: origin.lat, lng: origin.lng },
                              },
                              department: department.trim(),
                              code: 9999,
                            },
                          });
                        } else {
                          setInitialProps({
                            addressLocation,
                          });

                          handleSubmit(values);
                        }
                      }}
                      inProgress={inProgress}
                      updateError={updateError}
                      signaliseLocations={signaliseLocations}
                    />
                  )}
                </div>
              )}
            </GenericHero>
          </div>

          <div className={css.container}>
            <div>
              {isVRSCustomer ? (
                <div>
                  <p className={css.VRSquote}>
                    <span>
                      You have an account for <strong>work or home</strong>. Use the
                      button below to make calls.
                    </span>
                    <img
                      src={thumbsHand}
                      alt="Signalise thumbs up hand"
                      className={css.hands}
                    />
                  </p>
                  <PrimaryButton
                    className={css.primaryButton}
                    type="button"
                    onClick={VRSForm}
                  >
                    Make a Video Call
                  </PrimaryButton>
                </div>
              ) : (
                <div>
                  <p className={css.VRSquote}>
                    <img
                      src={surprisedHand}
                      alt="Signalise thumbs up hand"
                      className={css.hands}
                    />
                    <span>
                      You can also use the video service for <strong>work or home</strong> calls.
                      Please <strong><NamedLink name="ContactPage"> contact us</NamedLink></strong> for a quote. <br />
                      <strong><NamedLink name="LoginPage">Log in</NamedLink></strong> to use your VRS account.
                    </span>
                  </p>
                  <NamedLink name="ContactPage" className={css.secondaryButton}>
                    Request a quote
                  </NamedLink>
                </div>
              )}

              <div className={css.filterBox}>
                <div className={css.filterInput}>
                  <input
                    type="text"
                    placeholder="Search by name..."
                    value={params.name || ''}
                    onChange={(e) => setParams({ name: e.target.value })}
                  />
                </div>
                <ul>
                  {filterOptions.map((option) => (
                    <li key={option}>
                      <a
                        href={filterHref(option)}
                        onClick={handleFilterClick}
                        className={activeFilterClass(option)}
                      >
                        {option}
                      </a>
                    </li>
                  ))}
                  <li className={css.clearButton}>
                    <a
                      href={filterHref(null)}
                      onClick={(e) => {
                        e.preventDefault();
                        setParams({ beginsWith: undefined, name: undefined });
                      }}
                    >
                      Clear
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className={css.organisationContainer}>
              <div>
                <p className={css.organisationMessage}>
                  <strong>Are you from an organisation?</strong> This directory is for Deaf users to make calls. To use the video relay service, please <strong><NamedLink name="LoginPage">log in here</NamedLink></strong>.
                </p>
              </div>
              {directoryLoading && (
                <div className={css.loading}>Loading...</div>
              )}
              {directoryList.length === 0 && <div>No results found</div>}
              <ul className={css.organisationList}>
                {directoryList.map((item) => {
                  // Split name to put bracketed content on new line
                  const nameMatch = item.name.match(/^(.*?)(\s*\(.*\))$/);
                  const displayName = nameMatch ? (
                    <>
                      {nameMatch[1]}
                      <br />
                      {nameMatch[2].trim()}
                    </>
                  ) : item.name;

                  return (
                    <li key={item.id}>
                      <Link
                        to={{
                          pathname: `/directory/${item.id}`,
                          state: { organisation: item, params: params },
                        }}
                      >
                        <OrganisationLogo organisation={item} />
                        <h3>{displayName}</h3>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              {pageMeta.lastPage > 1 && (
                <ReactPaginate
                  className={css.pagination}
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={2}
                  pageCount={pageMeta.lastPage}
                  initialPage={pageMeta.currentPage - 1}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                  hrefBuilder={(page, pageCount, selected) => {
                    const pageLocation = globalThis.location.pathname;
                    const searchParams = new URLSearchParams(
                      globalThis.location.search.replace('?', '')
                    );
                    searchParams.set('page', page.toString());

                    return pageLocation + '?' + searchParams.toString();
                  }}
                />
              )}
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.currentUser,
  currentUserLoading: state.user.currentUserLoading,
  scrollingDisabled: isScrollingDisabled(state),
});

export default connect(mapStateToProps, null)(DirectoryPage);
